import { create } from "zustand";

/**
 * Minimal auth snapshot store.
 * Source of truth remains AuthContext (useReducer + checkAuth flow).
 * This store is a lightweight cache for components that need auth state
 * outside the React tree (e.g., query functions, utility code).
 *
 * Call syncFromContext(user, token, isAuthenticated) inside AuthProvider
 * whenever auth state changes to keep the two in sync.
 */
const useAuthStore = create((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  syncFromContext: (user, token, isAuthenticated) =>
    set({ user, token, isAuthenticated }),

  clear: () => set({ user: null, token: null, isAuthenticated: false }),
}));

export default useAuthStore;
